// state
const state = {
  accessToken: '',
  accessTokenGraph: '',
  account: undefined,
  group: '',
  mock: false,
  msalConfig: {
    auth: {
      clientId: process.env.VUE_APP_APP_REG_CLIENT_ID,
      authority: `https://login.microsoftonline.com/${process.env.VUE_APP_TENANT_ID}`,
      redirectUI: process.env.VUE_APP_LOGIN_REDIRECT,
    },
    cache: {
      cacheLocation: 'localStorage',
    },
  },
  notifications: [],
  modalView: {
    text: '',
    visible: false,
  },
}

// getters
const getters = {
  getModalView(state) {
    return state.modalView
  },
  getAccount(state) {
    return state.account
  },
  getAccessToken(state) {
    return state.accessToken
  },
  getAccessTokenGraph(state) {
    return state.accessTokenGraph
  },
  getGroup(state) {
    return state.group
  },
  getNotifications(state) {
    return state.notifications
  },
  getPermissionReuseTemplate(state) {
    return state.group === process.env.VUE_APP_ADMIN
  },
  getPermissionProgramReport(state) {
    return state.group === process.env.VUE_APP_ADMIN
  },
  getPermissionLoadTemplate(state) {
    return state.group === process.env.VUE_APP_ADMIN
  },
  // NEW SIMULATION BUTTON
  getPermissionNewSimulation(state) {
    return state.group === process.env.VUE_APP_ADMIN ? true : false
  },
  // CHECK STATUS
  getPermissionCheckStatus(state) {
    return state.group === process.env.VUE_APP_ADMIN ||
      state.group === process.env.VUE_APP_BASIC
      ? true
      : false
  },
  getPermissionDownloadSimulationExcel(state) {
    return (
      state.group === process.env.VUE_APP_ADMIN ||
      state.group === process.env.VUE_APP_BASIC ||
      state.group === process.env.VUE_APP_READER
    )
  },
  // DOWNLOAD SIMULATION TEMPLATE
  getPermissionDownloadSimulationTemplate(state) {
    //
    return state.group === process.env.VUE_APP_ADMIN ||
      state.group === process.env.VUE_APP_BASIC
      ? true
      : false
  },
  // FILE BUTTON
  getPermissionFile(state) {
    return state.group === process.env.VUE_APP_ADMIN ? true : false
  },
  // REMOVE BUTTON
  getPermissionRemove(state) {
    return state.group === process.env.VUE_APP_ADMIN ? true : false
  },
  // DISPLAY ALL SIMULATIONS
  getPermissionViewSimulations(state) {
    return state.group === process.env.VUE_APP_ADMIN ||
      state.group === process.env.VUE_APP_READER
      ? true
      : false
  },
  // MARK SIMULATION AS VISIBLE/NOT VISIBLE
  getPermissionVisble(state) {
    return state.group === process.env.VUE_APP_ADMIN ||
      state.group === process.env.VUE_APP_BASIC
      ? true
      : false
  },
  getPermissionVisbleAction(state) {
    return state.group === process.env.VUE_APP_ADMIN
  },
  // ACCESS VIEW GENERAL PARAMETRIZATION CONTENT
  getPermissionGeneralParametrizationView(state) {
    return state.group === process.env.VUE_APP_ADMIN ||
      state.group === process.env.VUE_APP_BASIC
      ? true
      : false
  },

  // ACCESS VIEW HVO EXPORTS CONTENT
  getHvoExportsView(state) {
    return state.group === process.env.VUE_APP_ADMIN ||
      state.group === process.env.VUE_APP_BASIC
      ? true
      : false
  },
  // display Program Inform
  getPermissionInformProgramView(state) {
    return state.group === process.env.VUE_APP_ADMIN ? true : false
  },
  getPermissionIntegrationsDataView(state) {
    return state.group === process.env.VUE_APP_ADMIN ? true : false
  },
  getPermissionRefreshNomsView(state) {
    return state.group === process.env.VUE_APP_ADMIN ||
      state.group === process.env.VUE_APP_BASIC
      ? true
      : false
  },
}

// actions
const actions = {
  async getGroup() {
    const url = process.env.VUE_APP_URL + '/authorisation'
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + state.accessToken,
          authorizationgraph: 'Bearer ' + state.accessTokenGraph,
          'Cache-Control': 'no-cache',
          user: state.account.username,
        },
      })
      return response.json()
    } catch (error) {
      console.error(error)
      return error
    }
  },
}

// mutations
const mutations = {
  setAccessToken(state, token) {
    state.accessToken = token
  },
  setAccessTokenGraph(state, token) {
    state.accessTokenGraph = token
  },
  setAccount(state, account) {
    state.account = account
  },
  SET_GROUP(state, group) {
    state.group = group
  },
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications
  },
  SET_MODALVIEW(state, modalView) {
    state.modalView = modalView
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
